import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { TweenMax } from 'gsap'

const Wrapper = styled.div`
  background-color: ${props => props.theme.main.bg};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 36em;
  z-index: 1;
  overflow: hidden;

  .parallax-panel__inner {
    height: 100%;
    width: 100%;
    position: relative;
  }
`

export default class ParallaxPanel extends React.Component {
  static propTypes = {
    children: PropTypes.object.isRequired,
    mobile: PropTypes.bool.isRequired,
  }

  windowHeight = 0
  panel = null
  animation = true
  shouldAnimate = !this.props.mobile
  addListeners = this.addListeners.bind(this)
  removeListeners = this.removeListeners.bind(this)
  handleScroll = this.handleScroll.bind(this)
  handleResize = this.handleResize.bind(this)

  componentDidMount () {
    this.panel = typeof document !== 'undefined' && document.querySelector('.parallax-panel__inner')
    this.handleResize()

    if (this.props.mobile) return
    setTimeout(() => {
      this.handleScroll()
    }, 100)
  }

  componentWillReceiveProps (next) {
    const { mobile } = this.props

    if (!next.mobile && next.mobile !== mobile) {
      this.addListeners()
    }

    if (next.mobile && next.mobile !== mobile) {
      this.removeListeners()
    }

    if (next.reset && !mobile) {
      this.handleScroll()
    }
  }

  componentWillUnmount () {
    this.removeListeners()
  }

  addListeners () {
    if (typeof window === 'undefined') return
    this.windowHeight = window.innerHeight
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
  }

  removeListeners () {
    TweenMax.to(this.image, 0, { y: 0 })
    if (typeof window === 'undefined') return
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll () {
    const offset = this.panel.getBoundingClientRect().top * -1
    if (offset > this.windowHeight && this.animating) {
      this.animating = false
      return
    }
    if (offset <= this.windowHeight && !this.animating) {
      this.animating = true
    }
    TweenMax.to(this.image, 0, { y: offset/5 })
  }

  handleResize () {
    this.windowHeight = typeof window !== 'undefined' && window.innerHeight
  }

  render () {
    const { children } = this.props
    return (
      <Wrapper className="parallax-panel">
        <div ref={el => this.image = el} className="parallax-panel__inner">
          { children }
        </div>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/ParallaxPanel.js